enum CommentTargetType {
  FLOW = 1,
  FLOW_MODEL = 2,
  STEP_TASK = 3
}

export default CommentTargetType;
